import axios from "axios";
import BeEndpoints from "./endpoints";

const axiosClient = axios.create();

axiosClient.defaults.baseURL = BeEndpoints.BASE_BE_URL;

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

// All request will wait 2 seconds before timeout
axiosClient.defaults.timeout = 10000;

axiosClient.defaults.withCredentials = false;

export default axiosClient;
